import React, { useEffect, useState } from 'react';
import { Col, Row, Form } from 'react-bootstrap';

import { shuffleArray } from 'utils';

import styles from 'assets/scss/wizard/emetSectionForm.module.scss';

const EmetSectionForm = ({ currentQuestion, onSelectAnswer }) => {
    
    const [answers, setAnswers] = useState([]);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
	
    useEffect(() => {
        
        if (currentQuestion && Array.isArray(currentQuestion.answers)) {
            setSelectedAnswer(null);
            setAnswers(shuffleArray(currentQuestion.answers));
        }
    }, [currentQuestion]);

    const handleOptionChange = (e) => {
        const selectedValue = e.target.value; // Obtiene el valor de la opción seleccionada
        const answer = answers.find(answer => answer.option === selectedValue); // Busca la respuesta que coincida
        setSelectedAnswer(answer);
        onSelectAnswer(answer);
    };
    
    return (
        <>
            <Row className={`${styles.instruction}`}>
                <Col>{currentQuestion.question_instruction}</Col>
            </Row>
            <Row className={`${styles.question} mt-3`}>
                <Col>{currentQuestion.question}</Col>
            </Row>
            <Row className={`${styles.answerOptions} mt-3`}>
                {answers.map((answer, index) => (
                    <Col key={index} md={4}>
                        <div className="mb-2">
                            <Form.Check type="radio" id={`answer-${index}`}>
                                <Form.Check.Input
                                    type="radio"
                                    name={`userAnswer-${currentQuestion.question_id}`} 
                                    value={answer.option}
                                    checked={selectedAnswer?.option === answer.option}
                                    onChange={handleOptionChange}
                                />
                                <Form.Check.Label className="ms-2">{answer.option}</Form.Check.Label>
                            </Form.Check>
                        </div>
                    </Col>
                ))}
            </Row>
        </>
    );
};

export default EmetSectionForm;